/* eslint-disable camelcase */

import isEmpty from 'lodash/isEmpty'

class ContentSchema {
    static getUrl() {
        return window.location.href || null
    }

    static getOrigin() {
        return window.location.origin || null
    }

    static getResourceRef() {
        return window.location.pathname || null
    }

    static getTitle() {
        const meta = Array.from(document.getElementsByTagName('meta'))

        const [metaTitle] = meta
            .filter((elem) => elem.name === 'title')
            .map((elem) => elem.content)

        const elementTitle = document.getElementsByTagName('title')[0].innerHTML

        return metaTitle || elementTitle || null
    }

    static getAuthor() {
        const meta = Array.from(document.getElementsByTagName('meta'))

        const [author] = meta
            .filter((elem) => elem.name === 'author')
            .map((elem) => elem.content)

        return author || null
    }

    static getReferer() {
        return document.referrer || null
    }

    // TODO:: Add validation here to ensure the correct data types are being sent accross the wire
    static content({
        author = null,
        title = null,
        origin = null,
        post_id = null,
        post_type = null,
        prev_page = ContentSchema.getReferer() || null,
        resource_ref = null,
        taxonomies = null,
        url = null,
    }) {
        if (isEmpty(taxonomies)) {
            // eslint-disable-next-line no-param-reassign
            taxonomies = null
        }

        return {
            author,
            title,
            origin,
            post_id,
            post_type,
            prev_page,
            resource_ref,
            taxonomies,
            url,
        }
    }
}

export default ContentSchema
